import { Flex, Box } from 'theme-ui'
import { ChevronDownIcon } from 'components/Icon'
import { ChangeEvent } from 'react'
import { ListTypes } from 'pages/Dashboard'

export type TableBySelectProps = {
  disabled?: boolean
  defaultValue?: ListTypes
  onSelectChange: (value: ListTypes) => void
}
export function TableBySelect({
  disabled = false,
  defaultValue = 'student',
  onSelectChange,
}: TableBySelectProps) {
  function handleSelectChange(e: ChangeEvent<any>) {
    if (disabled) return
    onSelectChange(e.target.value)
  }

  return (
    <Flex sx={{ userSelect: 'none' }}>
      <Flex sx={{ pl: 2, position: 'relative' }}>
        <Box
          data-cy="table-select"
          aria-label="table-select"
          as="select"
          defaultValue={defaultValue}
          variant="text.h1"
          sx={{
            pr: 5,
            position: 'relative',
            color: 'text',
            fontWeight: 'heading',
            appearance: 'none',
            border: 0,
            background: 'none',
            outline: 'none',
            zIndex: 2,
            transition: '0.4s ease-in-out',
            opacity: disabled ? 0.6 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            '&:after': {
              content: '""',
            },
          }}
          onChange={handleSelectChange}>
          <option value="student">Students</option>
          <option value="tmatt">DC Teacher Training</option>
          <option value="refresher">
            Refresher DC Teacher Training
          </option>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: '5px',
            pointerEvents: 'none',
          }}>
          <ChevronDownIcon />
        </Box>
      </Flex>
    </Flex>
  )
}
